module.exports = __webpack_public_path__ + "img/bella_mama_logo.c1aa10a3.png";